export const logEvent = function (category: string, action?: string, eventName?: string, eventValue?: string): void {
    // Track event in Matomo Tag Manager
    window['_mtm'] = window['_mtm'] || [];
    window['_mtm'].push({
        event: 'maEvent',
        eventCategory: category,
        eventAction: action,
        eventName: eventName,
        eventValue: eventValue,
    });
};
